import useExperiments from '~/stores/useExperimentsStore';
import { useBrand } from '~/composables/useBrand';
import { useProductFlags } from '~/modules/featureControl/composables/useProductFlags';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import useConsolidatedMemberStore from '~/stores/useConsolidatedMemberStore';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';

/**
 * Whether a Modiface virtual try-on indicator should be inserted as a carousel image on the PDP.
 */
export default function useVtoImageIndicator() {
  const {
    experimentFlags: { isImageIndicatorStylingEnabled, isImageARIndicatorEnabled },
  } = useExperiments();

  const { isMasterProductFlag, isModifaceEnabledFlag } = useProductFlags();
  const { isShopTheSetExpEnabled } = useFeatureEligibility();
  const { memberFlags } = storeToRefs(useConsolidatedMemberStore());
  const {
    killswitches: { isModifaceEnabled },
  } = useKillswitches();
  const { isMcom } = useBrand();

  return computed(
    () =>
      isImageIndicatorStylingEnabled &&
      isImageARIndicatorEnabled &&
      isModifaceEnabled &&
      (isModifaceEnabledFlag || !!memberFlags.value?.isModifaceEnabledFlag) &&
      (!isMasterProductFlag || isShopTheSetExpEnabled) &&
      isMcom,
  );
}
